// biome-ignore-all lint/suspicious/noConsole: dev-only DevTools helpers intentionally use console
import { inlineSqlParams } from '@pkg/shared/logger/sql'
import { environmentManager, hashKey, QueryClient, type QueryKey } from '@tanstack/react-query'

/**
 * Hashes local SQL queries to their inlined SQL so cache identity and DevTools
 * row labels both show the actual statement. Reads sql/parameters directly from
 * the queryKey (TanStack's hash fn doesn't get meta). Stays in lockstep with
 * the queryKey shape built by `local*QueryOptions`:
 *   ['app', 'query', kind, sql, keyParams]
 */
const sqlQueryKeyHashFn = (key: QueryKey): string => {
  if (!Array.isArray(key) || key[0] !== 'app' || key[1] !== 'query') return hashKey(key)
  const kind = key[2] as string
  const sql = key[3] as string
  const params = JSON.parse(key[4] as string) as readonly unknown[]
  return `${inlineSqlParams(sql, params)} -- ${kind}`
}

export const localQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: true,
      refetchOnWindowFocus: true,
      refetchOnMount: false,
      networkMode: 'always',
      retry: 0,
      enabled: !environmentManager.isServer(),
      queryKeyHashFn: sqlQueryKeyHashFn,
    },
    mutations: {
      throwOnError: true,
      networkMode: 'always',
    },
  },
})
